<template>
  <div class="w-full max-w-content-xl mx-auto">
    <h2 class="font-primary font-extrabold text-blue-brand text-28 md:text-32 leading-1 -tracking-1/2 px-5 md:px-0">Bookings</h2>
    <template v-if="pendingBookings.length > 0">
      <div class="p-2.5 md:px-5 xl:px-0 md:py-5 md:grid grid-cols-2 lg:grid-cols-3 gap-4">
        <div v-for="(booking, index) in pendingBookings" :key="index" class="w-full h-full mb-2.5 md:mb-0">
          <adventure-booking-preview :booking="booking"></adventure-booking-preview>
        </div>
      </div>
    </template>
    <div v-else class="max-w-content-sm px-5 py-10 mx-auto">
      <p class="text-center text-16 lg:text-20 leading-1.6 mb-5">You don’t currently have any bookings. Why not start your adventure today?</p>
      <a :href="adventuresUrl" class="block button mx-auto max-w-280 lg:max-w-360 mb-5 lg:mb-10">View adventures</a>
    </div>
    <h2 class="font-primary font-extrabold text-blue-brand text-28 md:text-32 leading-1 -tracking-1/2 px-5 md:px-0">Completed Bookings</h2>
    <template v-if="completedBookings.length > 0">
      <div class="p-2.5 md:px-5 xl:px-0 md:py-5 md:grid grid-cols-2 lg:grid-cols-3 gap-4">
        <div v-for="(booking, index) in completedBookings" :key="index" class="w-full h-full mb-2.5 md:mb-0">
          <adventure-booking-preview :booking="booking"></adventure-booking-preview>
        </div>
      </div>
    </template>
    <div v-else class="max-w-content-sm px-5 py-10 mx-auto">
      <p class="text-center text-16 lg:text-20 leading-1.6 mb-5">You don’t currently have any completed bookings.</p>
    </div>
  </div>
</template>

<script>
import Route from '../src/Route';
import AdventureBookingPreview from './AdventureBookingPreview.vue';
import { parseISO } from 'date-fns';

export default {
  components: { AdventureBookingPreview },

  data() {
    return {
      bookings: [],
      loading: false,
      error: null,
    };
  },

  computed: {
    pendingBookings() {
      return this.bookings.filter((booking) => {
        return new Date <= parseISO(booking.end_date);
      });
    },

    completedBookings() {
      return this.bookings.filter((booking) => {
        return new Date > parseISO(booking.end_date);
      });
    },

    adventuresUrl() {
      return Route('adventures.index');
    },
  },

  created() {
    this.getBookings();
  },

  methods: {
    getBookings() {
      this.loading = true;
      this.error = null;

      axios
        .get(Route('json.bookings.index'))
        .then((response) => {
          if (response.status === 200) {
            this.bookings = response.data.bookings;
          } else {
            throw 'There was a problem.';
          }
        })
        .catch((error) => {
          this.error = 'Sorry there was a problem loading bookings.';
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
}
</script>
